var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotonDePago(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7914 14.4256C10.4572 14.7599 9.90858 14.7599 9.5743 14.4256C7.90287 12.7542 7.90287 10.037 9.5743 8.36561L14.0657 3.87418C15.7372 2.20275 18.4543 2.20275 20.1257 3.87418C21.7972 5.54561 21.7972 8.26275 20.1257 9.93418L18.8949 11.165C18.561 11.4989 18.0197 11.4994 17.6852 11.166C17.3508 10.8327 17.3498 10.2915 17.6828 9.95696L18.9086 8.72561C19.92 7.72275 19.92 6.09418 18.9086 5.09132C17.9057 4.07989 16.2772 4.07989 15.2743 5.09132L10.7914 9.57418C9.78001 10.577 9.78001 12.2056 10.7914 13.2085C11.1429 13.5427 11.1429 14.0913 10.7914 14.4256ZM13.2086 9.57418C13.5429 9.23989 14.0914 9.23989 14.4257 9.57418C16.0972 11.2456 16.0972 13.9627 14.4257 15.6342L9.9343 20.1256C8.26287 21.797 5.54573 21.797 3.8743 20.1256C2.20287 18.4542 2.20287 15.737 3.8743 14.0656L5.10128 12.8386C5.43566 12.5035 5.97837 12.5035 6.31311 12.8383C6.31322 12.8384 6.31334 12.8385 6.31311 12.839L6.31378 12.8397C6.64783 13.1748 6.64767 13.7172 6.31343 14.0522L5.09144 15.2742C4.08001 16.277 4.08001 17.9056 5.09144 18.9085C6.0943 19.9199 7.72287 19.9199 8.72573 18.9085L13.2086 14.4256C14.22 13.4227 14.22 11.7942 13.2086 10.7913C12.8572 10.457 12.8572 9.90846 13.2086 9.57418Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonDePago);
export default __webpack_public_path__ + "static/media/boton-de-pago.6feb795c8d48507ff7647192447fc56a.svg";
export { ForwardRef as ReactComponent };